import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { GroupService } from "../shared/group.service";
import { PrivilegeService } from "../../../staff/Shared/privilege.service";
import { Group } from "../shared/group.model"

import { ConfirmationdialogService } from "../../../utility/shared/confirmationdialog.service";
import { ToasterserviceService } from "../../../utility/shared/toasterservice.service";
import { IndividualConfig, ToastrService } from 'ngx-toastr';
import { Toastpayload } from "../../../utility/shared/toastpayload";

@Component({
  selector: 'app-grouplist',
  templateUrl: './grouplist.component.html',
  styleUrls: ['./grouplist.component.css']
})

export class GrouplistComponent implements OnInit {

  displayedColumns: string[] = ['GroupName', 'Center', 'Branch', 'Details', 'New'];
  ChequeList$ = [''];
  dataSource = new MatTableDataSource<any>();
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  IsAdd: boolean;
  IsEdit: boolean;
  IsDelete: boolean;
  IsView: boolean;
  IsPrint: boolean;
  toast: Toastpayload;

  constructor(private router: Router, private groupService: GroupService,
    private privilegeService: PrivilegeService,
    private toasterserviceService: ToasterserviceService,
    private confirmationdialogService: ConfirmationdialogService,) {
    this.dataSource.paginator = this.paginator;
  }

  ngOnInit() {
    this.getGroupList();
    this.dataSource.paginator = this.paginator;
  }

  getGroupList() {
    this.groupService.FetchGroupList().subscribe(data => {
      // this.ChequeList$=data;
      this.dataSource.data = data;
    })
  }

  public AddNewGroup() {
    this.router.navigate(['/group']);
  }

  EditGroup(Group: any) {
    this.router.navigate(['/group', Group.Id]);
  }

  applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // MatTableDataSource defaults to lowercase matches
    this.dataSource.filter = filterValue;
  }

  // Delete with Toastr messsage
  DeleteGroup(element: any) {

    this.toast = {
      message: "The centre have been deleted",
      title: 'Centre deletion',
      ic: {
        timeOut: 3000,
        closeButton: true,
      } as IndividualConfig,
      type: 'success',
    };

    let title: string = "Confirmation";
    let message: string = "If you continue, the Group will be removed. Are you sure? ";
    let btnOkText: string = "Yes";
    let btnCancelText: string = 'No, Exit';

    this.confirmationdialogService.openModalWithClass(title, message, btnOkText, btnCancelText)
      .subscribe(confirmed =>
      // console.log('User confirmed:', confirmed)
      {
        if (confirmed == true) {
          // centrelink deletion
          this.IUDCentre(element);
        }
        else {

          // console.log(confirmed);
          this.toast.message = 'You are cancelled the group deletion.!'
          this.toast.type = 'warning';
          this.toasterserviceService.showToast(this.toast);
        }
      });
  }

  // centre delete action
  IUDCentre(element: any) {

    this.groupService.selectedGroup = new Group;
    this.groupService.selectedGroup.Id = element.Id;  // GroupId
    this.groupService.selectedGroup.IsActive = 0;  // deactivate
    this.groupService.selectedGroup.Flag = 3; // deactivate Flag
    // IUD action
    this.groupService.IUDGroup(this.groupService.selectedGroup)
      .toPromise()
      .then(data => {
        this.router.navigate(['/grouplist']);
        // showing message:
        this.toasterserviceService.showToast(this.toast);
      })
  }
}
